import { useEffect, useRef, useState } from "react";
import isRunningOnMobile from "../utils/isRunningOnMobile";

const useGlobalRefreshLogicHook = ({ onRefresh }: { onRefresh: Function }) => {
  const [startY, setStartY] = useState(0);
  const [endY, setEndY] = useState(0);
  const [isRefreshing, setIsRefreshing] = useState(false);

  const containerRef = useRef<any>(null);
  const handleTouchStart = (event: any) => {
    if (!isRunningOnMobile()) {
      return;
    }
    console.log("touche start");
    if (event.touches) {
      setStartY(event.touches[0].pageY);
      containerRef?.current?.addEventListener("touchend", handleTouchEnd);
    }
  };

  const handleTouchEnd = async (event: any) => {
    if (!isRunningOnMobile()) {
      return;
    }
    if (event.changedTouches) {
      setEndY(event.changedTouches[0].pageY);
      const container = containerRef?.current;
      const scrolled = container?.scrollTop;
      containerRef?.current?.removeEventListener("touchend", handleTouchEnd);
      if (
        scrolled &&
        scrolled <= 0 &&
        window.scrollY <= 10 &&
        startY < endY &&
        endY - startY > 30
      ) {
        setIsRefreshing(true);
        await onRefresh();
        setIsRefreshing(false);
      }
    }
  };

  useEffect(() => {
    if (isRunningOnMobile()) {
      const container = containerRef?.current;
      container?.addEventListener("touchend", handleTouchEnd);

      return () => {
        container?.removeEventListener("touchend", handleTouchEnd);
      };
    }
  }, []);
  return {
    isRefreshing,
    setIsRefreshing,
    containerRef,
    handleTouchStart,
  };
};

export default useGlobalRefreshLogicHook;
